import React, { useState, useEffect, useRef } from 'react';
import _ from "lodash";
import { useId } from "../../hooks/use-id";

/**
 * Componente de preguntas de la sección de ayuda sin login
 * @param {object} txtAyuda - textos de ayuda
 * @returns {JSX.Element} - PreguntasSinLogin
 */
export const PreguntasSinLogin = ({ txtAyuda }) => {
    const [acordeonActivo, setAcordionActivo] = useState();
    const [alturaAcordeon, setAlturaAcordeon] = useState();

    const contenedorAcordeon = useRef(null);

    useEffect(() => {
        datoAlturaAcordeon();
        window.addEventListener('resize', datoAlturaAcordeon)
        return () => {
            window.removeEventListener('resize', datoAlturaAcordeon)
        }
    }, [acordeonActivo, alturaAcordeon])


    const datoAlturaAcordeon = () => {
        if (!!contenedorAcordeon.current) return setAlturaAcordeon(contenedorAcordeon.current.scrollHeight);
        setAlturaAcordeon(0);
    }

    const activadorAcordeon = (index) => {
        let nuevoValor = acordeonActivo === index ? "" : index;
        setAcordionActivo(nuevoValor)
    }

    return (
        <>
            {
                txtAyuda &&
                Object.keys(txtAyuda).map((item, index) => {
                    return  <AcordeonItem
                            key={index}
                            item={txtAyuda[item]}
                            index={index}
                            isActive={acordeonActivo === index}
                            onToggle={activadorAcordeon}
                        />
                })
            }
        </>
    )
}

const AcordeonItem = ({ item, index, onToggle, isActive }) => {
  const contentId = useId();
  const buttonId = useId();

  return (
    <div>
      <button
        id={buttonId}
        aria-expanded={isActive}
        aria-controls={contentId}
        className={`focusable-secondary ${isActive ? "acordeon_active" : ""} acordeon px-3 py-2`}
        onClick={() => onToggle(index)}
      >
        {item.pregunta}
        <i aria-hidden={true} className={`fas fa-chevron-down fa-sm ${isActive ? "icono-activo" : ""}`}></i>
      </button>

      {isActive && (
        <div
          id={contentId}
          role="region"
          aria-labelledby={buttonId}
          className="opcionAcordeon p-3 relative"
        >
          {item.respuesta1 && (
            <p dangerouslySetInnerHTML={{ __html: item.respuesta1 }} />
          )}

          {item.respuesta2 && (
            <>
              <p dangerouslySetInnerHTML={{ __html: item.respuesta2?.txt1 }} />
              <p dangerouslySetInnerHTML={{ __html: item.respuesta2?.txt2 }} />
            </>
          )}

          {item.lista && (
            <ol>
              <li dangerouslySetInnerHTML={{ __html: item.lista?.opc1 }} />
              <li dangerouslySetInnerHTML={{ __html: item.lista?.opc2 }} />
              <li dangerouslySetInnerHTML={{ __html: item.lista?.opc3 }} />
            </ol>
          )}
        </div>
      )}
    </div>
  );
};